
export class CustomerSiteAddress
{
    addressid: number;
    customersitecode: string;
    addresstypecode: string;
    addresstype: string;
    address: string;
    taluk: string;
    pincode: string;
    pincodelocation: string;
    floortypecode: string;
    floortype: string;
    recordstatuscode: string;
    recordstatus: string;
}